import queryString from "query-string";
import { useLocation, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Loader } from "../../components";
import pages from "../../constants/pages";
import { useAxios, useComponent } from "../../hooks";
import { alert } from "../../redux/slices/alertSlice";
import Form from "./brand details components/Form";
import {
  brandDetailsObject,
  objectFromResponse,
} from "./brand details components/brandDetailObject";
import { signInMember } from "../../redux/slices/memberSlice";

export default function BrandDetails() {
  const axios = useAxios();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();

  const { loader } = useComponent();

  const {
    isAdminVerified,
    parentBrandVerified,
    location,
    languages,
    categories,
  } = useSelector((state) => state.memberDetails);

  const agencyID =
    useSelector((state) => state.memberDetails.agencyID) ||
    sessionStorage.getItem("agencyID");

  const ID = useSelector((state) => state.memberDetails?.activeBrand.ID);

  const [editState, setEditState] = useState(true);
  const [formData, setFormData] = useState(brandDetailsObject);
  const [list, setList] = useState({
    categories: categories || [],
    locations: location || [],
    languages: languages || [],
  });

  var brandID = !state?.brandID ? ID : state?.brandID;

  const multiBrand = queryString.parse(window.location.search).newMultiBrand;

  if (queryString.parse(window.location.search).brandID) {
    brandID = queryString.parse(window.location.search).brandID;
  }

  useEffect(() => {
    if (!!brandID) {
      setEditState(false);
    }

    if (multiBrand) {
      setEditState(true);
    }
  }, [brandID, multiBrand]);

  useEffect(() => {
    loader.start(!isAdminVerified || parentBrandVerified === 0 ? 4 : 1);

    if (!isAdminVerified || parentBrandVerified === 0) {
      axios({
        url: "/brand/getAllBusinessCategories",
        method: "GET",
        disableRedirect: true,
      }).then((response) => {
        if (response.status) {
          setList((prev) => ({
            ...prev,
            categories: response.data,
          }));
          loader.apiComplete();
        }
      });

      axios({
        url: "/getAllCountries",
        method: "GET",
        disableRedirect: true,
      }).then((response) => {
        if (response.status) {
          setList((prev) => ({
            ...prev,
            locations: response.data,
          }));
          loader.apiComplete();
        }
      });

      axios({
        url: "/getAllLanguages",
        method: "GET",
        disableRedirect: true,
      }).then((response) => {
        if (response.status) {
          setList((prev) => ({
            ...prev,
            languages: response.data,
          }));
          loader.apiComplete();
        }
      });
    }

    if (!!brandID && !multiBrand) {
      axios({
        url: "/getBrand/" + brandID,
        method: "GET",
      }).then((response) => {
        if (response.status) {
          if (response.data?.is_brand_verified === 2) {
            dispatch(
              alert({
                type: "info",
                message: "Brand has been rejected by the admin!",
              })
            );
            dispatch(signInMember());
            navigate(pages.signIn.route);
          }
          setFormData(objectFromResponse(response.data, agencyID));
          loader.apiComplete(1);
        }
      });
    } else {
      setFormData((prev) => ({
        ...prev,
        agencyID: agencyID,
      }));
      loader.apiComplete();
    }
  }, [
    agencyID,
    multiBrand,
    axios,
    brandID,
    loader,
    parentBrandVerified,
    isAdminVerified,
    dispatch,
    navigate,
  ]);

  return (
    <Loader>
      <Form
        agencyID={agencyID}
        formData={formData}
        editState={editState}
        setEditState={setEditState}
        list={list}
        setFormData={setFormData}
      />
    </Loader>
  );
}
